import {
  MATERIAL_START,
  MATERIAL_SUCCESS,
  MATERIAL_ERROR,
} from './MaterialTypes';

const INITIAL_STATE = {
  loading: false,
  error: false,
  data: {
    docs: [],
  },
};

export default (state: any = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case MATERIAL_START:
      return { ...state, loading: true, error: null };

    case MATERIAL_SUCCESS:
      return { ...state, data: action.payload, loading: false };

    case MATERIAL_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
